import {BRAND_URL} from "../../helpers/api.routes";
import {requests} from "../../helpers/api.services";
import {IBrandPagination} from "./interface";

export const AdminBrandService = {
  getAll: (params: IBrandPagination) => requests.get(`${BRAND_URL}`, params),
  create: (payload: FormData) => requests.post(`${BRAND_URL}`, payload, true),
  getSingle: (id: number) => requests.get(`${BRAND_URL}/${id}`),
  update: (payload: FormData, id: number) =>
    requests.post(`${BRAND_URL}/${id}`, payload, true),
  delete: (id: number) => requests.delete(`${BRAND_URL}/${id}`),
  updatePosition: (ids: number[]) => requests.patch(`${BRAND_URL}`, {ids}),
  updateIsActive: (id: number) => requests.patch(`${BRAND_URL}/activate-deactivate/${id}`),
};
